module.exports = __webpack_public_path__ + "img/notion.4151b539.svg";